import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=218d1633&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=js&"
export * from "./Splash.vue?vue&type=script&lang=js&"
import style0 from "./Splash.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Splash.vue?vue&type=style&index=1&id=218d1633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d1633",
  null
  
)

export default component.exports